import styled from 'styled-components'

const NotFoundContainer = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.surface.sf300};
  color: ${({ theme }) => theme.colors.text.text700};
  width: 100%;
  text-align: center;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Heading = styled.h1`
  font-size: 4rem;
`

const SubHeading = styled.p`
  margin: 8px auto;
  text-transform: capitalize;
`

const BackToHomeBtn = styled.button`
  all: unset;
  cursor: pointer;
  border-radius: 4px;
  background-color: var(--azure-500);
  color: var(--white-op-88);
  font-size: 14px;
  padding: 10px 12px;
  width: 180px;
  margin-top: 16px;
`

export { NotFoundContainer, Heading, SubHeading, BackToHomeBtn }
